var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      title: _vm.$t(
        "label_essweb_shiftTypeMapping_dialog_newShiftTypeMappingTitle"
      ),
      width: "680",
      maxWidth: "680",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form" },
              [
                _c(
                  "v-col",
                  {
                    attrs: {
                      xs: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      cols: "12",
                    },
                  },
                  [
                    _c("AutoComplete", {
                      attrs: {
                        isRequired: "",
                        label:
                          "label_essweb_shiftTypeMapping_dialog_staffNameLabel",
                        items: _vm.StaffList,
                        filter: _vm.$staffFilter,
                        rules:
                          _vm.selectStaff == ""
                            ? _vm.$GetRules(["_Require_ArrRules"], [null])
                            : [],
                        chips: "",
                        "deletable-chips": "",
                        multiple: "",
                        "two-line": "",
                        avatar: "",
                        "item-text": "staff_code",
                        "item-value": "staff_id",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "selection.avatar",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _c("StaffAvatar", {
                                attrs: {
                                  src: data.item.staff_avatar,
                                  isTemp: data.item.is_temp,
                                  left: "",
                                  staff_name: data.item.preferred_name,
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "selection",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      data.item.preferred_name
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.avatar",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _c("StaffAvatar", {
                                attrs: {
                                  size: "36",
                                  isTemp: data.item.is_temp,
                                  src: data.item.staff_avatar,
                                  staff_name: data.item.preferred_name,
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "item.title",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _c("span", { staticClass: "text-body-2" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      data.item.preferred_name
                                    )
                                  ) + " "
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text--secondary text-caption-xs",
                                  },
                                  [_vm._v(_vm._s(data.item.staff_code))]
                                ),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.subtitle",
                          fn: function (ref) {
                            var data = ref.data
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$getCommonLangValue(
                                      data.item.job_post_name
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.selectStaff,
                        callback: function ($$v) {
                          _vm.selectStaff = $$v
                        },
                        expression: "selectStaff",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      xs: "12",
                      sm: "12",
                      md: "12",
                      lg: "12",
                      cols: "12",
                    },
                  },
                  [
                    _c("AutoComplete", {
                      attrs: {
                        isRequired: "",
                        items: _vm.ShiftTypeList,
                        label:
                          "label_essweb_shiftTypeMapping_dialog_staffTypeLabel",
                        "item-text": "shift_type_name",
                        "item-value": "uuid",
                        chips: "",
                        "small-chips": "",
                        "deletable-chips": "",
                        multiple: "",
                        rules: _vm.$GetRules(["_Require_ArrRules"], [null]),
                      },
                      model: {
                        value: _vm.selectType,
                        callback: function ($$v) {
                          _vm.selectType = $$v
                        },
                        expression: "selectType",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.onNew, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }